import React from 'react';
import { IconHelp } from '@tabler/icons-react';
import { Tooltip } from '@planne-software/uni/Tooltip';

import { useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { buildLegend } from '@src/domains/scheduling';
import { Legend, LegendArea, LegendBox, LegendLabel, LegendLabelSuggestedPrice, TopArea } from './styles';
import { LayoutColors } from '@src/core/theme';

const CalendarLegend = () => {
  const { i18n } = useTranslate();
  const { labels, showPriceDisclaimer } = buildLegend({
    showPriceDisclaimer: true,
    i18n: i18n as (key: string) => string,
  });

  return (
    <LegendArea>
      <TopArea>
        <Legend>
          <LegendLabel>{labels.available}</LegendLabel>
          <LegendBox bgColor={theme('successColor')} />
        </Legend>

        <Legend>
          <LegendLabel>{labels.current}</LegendLabel>
          <LegendBox borderColor={theme('selectionColor')} />
        </Legend>

        <Legend>
          <LegendLabel>{labels.unavailable}</LegendLabel>
          <LegendBox bgColor={theme('unavailableColor')} />
        </Legend>
      </TopArea>

      {showPriceDisclaimer && labels.priceDisclaimer ? (
        <Legend>
          <LegendLabelSuggestedPrice>{labels.priceDisclaimer}</LegendLabelSuggestedPrice>
          {labels.priceTooltip ? (
            <Tooltip label={labels.priceTooltip} enterTouchDelay={0}>
              <IconHelp style={{ cursor: 'pointer' }} size={24} color={LayoutColors.blackMain} />
            </Tooltip>
          ) : (
            <IconHelp style={{ cursor: 'pointer' }} size={24} color={LayoutColors.blackMain} />
          )}
        </Legend>
      ) : null}
    </LegendArea>
  );
};

export default CalendarLegend;
